import { Draft, produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_SUCCESS,
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS,
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_BY_DRAFT_REQUEST,
  CONTRACT_SETUP_BY_DRAFT_SUCCESS,
  CONTRACT_SETUP_PARTICIPANT_AUTHENTICATION_CHANGE,
} from '@app/store/actionTypes';
import {
  ContractSetupAction,
  contractSetupSetParticipants,
} from '@app/store/contract-setup/actions';

export interface MobileState {
  [id: string]: {
    phoneNumber?: string;
    realName?: string;
  };
}

const initialState: MobileState = {};

const reducer = produce((draft: Draft<MobileState>, action: ContractSetupAction) => {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
    case CONTRACT_SETUP_BY_DRAFT_REQUEST:
    case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST:
      return initialState;
    case CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_REQUEST: {
      Object.keys(draft).forEach((participantId) => {
        draft[participantId] = {};
      });
      return draft;
    }
    case CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_SUCCESS: {
      const { participantAuthentications } = action.payload;
      participantAuthentications.forEach((participantAuthentication) => {
        const { mobile, participantId } = participantAuthentication;
        if (mobile && participantId) {
          draft[participantId].phoneNumber = mobile.phoneNumber;
          draft[participantId].realName = mobile.realName;
        }
      });
      return draft;
    }
    case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS: {
      const { participants } = action.payload;
      participants.forEach((participant) => {
        const { participantId } = participant;
        draft[participantId] = {};
      });
      return draft;
    }
    case CONTRACT_SETUP_PARTICIPANT_AUTHENTICATION_CHANGE: {
      const { mobile, participantId } = action.payload;
      draft[participantId] = {
        phoneNumber: mobile.phoneNumber,
        realName: mobile.realName,
      };
      return draft;
    }
    case contractSetupSetParticipants.type: {
      const result: MobileState = {};

      action.payload.forEach(({ participantId }) => {
        result[participantId] = draft[participantId] ?? {};
      });

      return result;
    }
    case CONTRACT_SETUP_BY_DRAFT_SUCCESS: {
      const { participants } = action.payload;
      participants.forEach(({ id, verification }) => {
        if (verification.mobileIdentification) {
          draft[id] = {
            phoneNumber: verification.mobileIdentification.phoneNumber,
            realName: verification.mobileIdentification.name,
          };
        } else {
          draft[id] = {};
        }
      });
      return draft;
    }
    default:
      return draft;
  }
}, initialState);

export default reducer;
